import React from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import moment from 'moment';
import DocumentIcon from 'assets/images/Dashboard/document-text-profile.svg';
import SearchIcon from 'assets/images/Dashboard/search-pending.svg';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import DownloadIcon from 'assets/images/Dashboard/download-profile.svg';

const AppointmentTab = () => {
  const appointmentValue = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  const loading = useSelector(
    (state) => state?.profileSectionDataReducer?.loading
  );

  return (
    <div>
      {loading ? (
        <Loader />
      ) : appointmentValue?.appointment_history &&
        appointmentValue?.appointment_history.length > 0 ? (
        <>
          <div className="pt-16">
            <Row className="m-0">
              <Col sm={12} md={6} className="p-0">
                <div className="border-b border-detail-gray listCustomHeader">
                  <Row className="m-0 p-10 ">
                    <Col md={4} className="p-0">
                      <div className="fs-14 fc-998A7B lh-176 family_outfit_semiBold_600">
                        Consultation mode
                      </div>
                    </Col>
                    <Col md={4} className="p-0">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <div>
                          <Image src={SearchIcon} alt="icon" />
                        </div>
                        <div className="fs-14 fc-998A7B lh-176 family_outfit_semiBold_600">
                          Booking ID
                        </div>
                      </Stack>
                    </Col>
                    <Col md={4} className="p-0">
                      <div className="fs-14 fc-998A7B  lh-176 family_outfit_semiBold_600">
                        Date & Time
                      </div>
                    </Col>
                  </Row>
                </div>
                <Row className="bc-FFFFFF m-0 p-0">
                  {appointmentValue?.appointment_history.map((item, index) => {
                    return (
                      <Row className="m-0 p-0 flex items-center listAppointment">
                        <Col md={4}>
                          <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400 py-12">
                            {item?.consultation_type}
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400 py-12">
                            {item?.booking_id}
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400">
                            {moment(item?.appointment_date_time).format(
                              'DD MMM YYYY'
                            )}
                            <br />
                            <span className="fs-14 fc-202224 lh-176 family_outfit_regular_400">
                              {moment(item?.appointment_date_time).format(
                                'hh:mmA'
                              )}
                            </span>
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                </Row>
              </Col>
              <Col sm={12} md={6}>
                <div className="border-b border-detail-gray listCustomHeader">
                  <Row className="m-0 px-16 py-10">
                    <Col md={12} className="p-0">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center"
                      >
                        <div>
                          <Image src={SearchIcon} alt="icon" />
                        </div>
                        <div className="fs-16 fc-998A7B lh-16 family_outfit_medium_500">
                          Medical Records
                        </div>
                      </Stack>
                    </Col>
                  </Row>
                </div>
                <Row className="bc-FFFFFF m-0 p-0">
                  {appointmentValue?.appointment_history.map((item, index) => {
                    return (
                      <Row className="m-0 p-0 flex items-center listAppointmentProfile">
                        <Col md={12}>
                          <Stack
                            direction="horizontal"
                            className="flex justify-between"
                          >
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              <div>
                                <Image src={DocumentIcon} alt="icon" />
                              </div>
                              <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400">
                                <a
                                  href={item?.diagnosis_report || '#'}
                                  download={
                                    item?.diagnosis_report
                                      ? item?.diagnosis_report.split('/').pop()
                                      : 'license'
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="fs-14 fc-202224 lh-176 family_outfit_regular_400 cursor-pointer underline underline-offset-4"
                                >
                                  {item?.diagnosis_report &&
                                    item?.diagnosis_report.split('/').pop()}
                                </a>
                              </div>
                            </Stack>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              <div>
                                <a
                                  href={item?.diagnosis_report || '#'}
                                  download={
                                    item?.diagnosis_report
                                      ? item?.diagnosis_report.split('/').pop()
                                      : 'license'
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="fs-14 fc-202224 lh-176 family_outfit_regular_400 cursor-pointer underline underline-offset-4"
                                >
                                  <Image src={DownloadIcon} alt="icon" />
                                </a>
                              </div>
                            </Stack>
                          </Stack>
                        </Col>
                      </Row>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </div>
        </>
      ) : (
        <div className="flex justify-center pt-80">
          <div>
            <Image src={EmptyScreen} alt="icon" />
            <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center pt-30">
              Nothing here yet
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentTab;
